import styled, { css } from 'styled-components'
import { Spacing, Colors, Shadows, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const SegmentControl = styled.div<{ $isActive?: boolean }>`
  --color-default: ${Colors.Neutral50};
  --color-active: ${Colors.Neutral90};
  --color-hover: ${Colors.Neutral70};
  --background-default: ${Colors.Neutral5};
  --background-active: ${Colors.White};
  --background-hover: ${Colors.Neutral10};

  ${Typography.sizes.Body};
  font-weight: ${Typography.weights.medium};
  transition: all 0.2s ease-out;
  color: var(--color-default);
  background-color: var(--background-default);
  padding: ${Spacing.XS};
  border-radius: 8px;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.$isActive
      ? css`
          box-shadow: ${Shadows.lightShadowLow};
          background-color: var(--background-active);
          color: var(--color-active);
          z-index: 1;
        `
      : Media.Hover`
          &:hover {
            background-color: var(--background-hover);
            color: var(--color-hover);
          }
        `}
`

type Child = React.ReactElement<React.ComponentProps<typeof SegmentControl>>

export const SegmentControls = styled.div<{ children: Child[] }>`
  position: relative;
  display: flex;
  gap: 0;
  padding: ${Spacing['3XS']};
  border-radius: ${Spacing.XS};
  background-color: ${Colors.Neutral5};
`
